const states = {
  genai_faq_details: {
    //------------- GenAi FAQ ---------------
    faqs: [], //gf => genai faq
    gf_loading: false,
    gf_load_error: false,
    gf_search_key: "",
    gf_has_more: false,
    gf_pushing_id: null,
  },
}

export default states
